var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('restaurant-menu-settings-card',{attrs:{"bot":_vm.bot}}),_c('restaurant-menu-categories-list-card',{attrs:{"bot":_vm.bot}}),_c('restaurant-menu-products-list-card',{staticClass:"pb-6",attrs:{"bot":_vm.bot}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }